import Backbone from 'backbone';
import checkCookies from '../../../../Nav/Js/utils/checkCookies';
import $ from 'jquery';
import { isTouch } from '../others/Configuration';
import searchVendorFilters from './search-filters';
import 'component?js-PopupInline';
import 'component?js-PopinKoboRedirect';

/**
 * MasterView includes generic generics components.
 * It is attached to body html element.
 */
export default Backbone.View.extend({
  initialize: function () {
    this.detectScroll = this.detectScroll.bind(this);

    // check overall cookies weight
    checkCookies();

    // set initial scroll position
    this.lastScrollTop = 0;

    // handle upscroll / downscroll on touch devices
    $(window).on('touchmove', this.detectScroll);

    // init search input for mobile
    //this.initSearchInput();

    // init search filter toggle more
    this.initFilterToggle();

    // update user near store on geoloc update
    // this.listenTo(SharedDispatcher, 'geoloc:update', this.updateNearestStore);
  },

  events: {
    'click .js-toggleFilters': 'toggleFilters',
  },

  initSearchInput: function () {
    /* This hack was made because Safari iOS puts text form fields in relative position on focus, to enter text properly, but it seems to be not anymore mandatory */
    //if (isTouch) {
    //  /* bind events */
    //  $(document)
    //  .on('focus', 'input.js-HeaderSearch-input', function() {
    //    document.body.classList.add('fixfixed');
    //  })
    //  .on('blur', 'input.js-HeaderSearch-input', function() {
    //    document.body.classList.remove('fixfixed');
    //  });
    //}
  },

  initFilterToggle: function () {
    searchVendorFilters();
  },

  toggleFilters: function (e) {
    e.preventDefault();
    var isActiveClassName = 'isActive',
      filterContentClassName = '.Filters-content',
      $currentTarget = $(e.currentTarget),
      $filterContent = $currentTarget.prev(filterContentClassName);
    $filterContent.toggleClass(isActiveClassName);
    $currentTarget.toggleClass(isActiveClassName);
    $filterContent.toggleClass('allActive');
    $filterContent.scrollTop(0); // TODO: Vérifier que le scroll marche bien
  },

  detectScroll: function () {
    var top = $(window).scrollTop();
    if (top > this.lastScrollTop) {
      if (top > 100 && top >= this.lastScrollTop + 20) {
        // downscroll code
        if (!$('.js-Header-search').hasClass('isHidden-tablet')) {
          $('.js-Header-search').addClass('isHidden-tablet');
        }
      }
    } else if (top <= this.lastScrollTop - 20) {
      // upscroll code
      if ($('.js-Header-search').hasClass('isHidden-tablet')) {
        $('.js-Header-search').removeClass('isHidden-tablet');
      }
    }
    this.lastScrollTop = top;
  },
});
